/**
 * AndVArea - 面积图组件
 * 基于 Ant Design Charts Area
 */
import React from 'react';
import { Area } from '@ant-design/plots';
import { withBaseChart, parseJsonProp } from '../base/BaseChart';
import type { AndVAreaProps } from '../base/types';

// 使用 HOC 包装基础 Area 组件
const AreaWithBase = withBaseChart<AndVAreaProps>(Area, {
  chartType: 'AndVArea',
  defaultHeight: 300,
  defaultData: [
    { year: '1991', value: 3 },
    { year: '1992', value: 4 },
    { year: '1993', value: 3.5 },
    { year: '1994', value: 5 },
    { year: '1995', value: 4.9 },
    { year: '1996', value: 6 },
    { year: '1997', value: 7 },
    { year: '1998', value: 9 },
    { year: '1999', value: 13 },
  ],
});

/**
 * AndVArea 面积图组件
 */
export const AndVArea: React.FC<AndVAreaProps> = (props) => {
  const {
    // 字段
    xField,
    yField,
    seriesField,
    colorField,
    shapeField,
    sizeField,
    // JSON 配置
    line,
    point,
    // 布尔配置
    stack,
    percent,
    symmetry,
    diff,
    ...baseProps
  } = props;

  const chartProps: Record<string, any> = {
    ...baseProps,
  };

  // 添加字段配置
  if (xField) chartProps.xField = xField;
  if (yField) chartProps.yField = yField;
  if (seriesField) chartProps.seriesField = seriesField;
  if (colorField) chartProps.colorField = colorField;
  if (shapeField) chartProps.shapeField = shapeField;
  if (sizeField) chartProps.sizeField = sizeField;

  // 添加布尔配置
  if (stack !== undefined) chartProps.stack = (stack as any) === true || (stack as any) === 'true';
  if (percent !== undefined) chartProps.percent = (percent as any) === true || (percent as any) === 'true';
  if (symmetry !== undefined) chartProps.symmetry = (symmetry as any) === true || (symmetry as any) === 'true';
  if (diff !== undefined) chartProps.diff = (diff as any) === true || (diff as any) === 'true';

  // 解析 JSON 配置
  const lineConfig = parseJsonProp(line);
  if (lineConfig !== undefined) chartProps.line = lineConfig;

  const pointConfig = parseJsonProp(point);
  if (pointConfig !== undefined) chartProps.point = pointConfig;

  return <AreaWithBase {...chartProps} />;
};

export type { AndVAreaProps };
export default AndVArea;
